import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Upload, FileCode } from 'lucide-react';

export const ImportGcodeDialog = ({ open, onOpenChange, onImport }) => {
  const [text, setText] = useState('');

  const handleFile = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    const t = await f.text();
    setText(t);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl bg-card border-border">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><FileCode className="h-4 w-4 text-primary" /> G-kod import</DialogTitle>
          <DialogDescription className="text-xs text-muted-foreground">G-kod importalasa.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <label className="text-xs text-muted-foreground">Fajl feltoltes (.tap, .nc, .txt)</label>
            <input type="file" accept=".tap,.nc,.txt,.gcode,.ngc" onChange={handleFile} className="w-full mt-1 text-xs" />
          </div>
          <div>
            <label className="text-xs text-muted-foreground">Vagy illeszd be a kodot:</label>
            <textarea
              className="w-full h-64 mt-1 rounded-md bg-black/40 border border-border p-2 text-xs mono"
              value={text}
              onChange={e => setText(e.target.value)}
              placeholder="G90 G17 G21..."
            />
          </div>
          <div className="flex justify-end gap-2">
            <Button variant="secondary" onClick={() => onOpenChange(false)}>Megse</Button>
            <Button onClick={() => onImport(text)} disabled={!text.trim()}><Upload className="h-4 w-4 mr-1" /> Import</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ImportGcodeDialog;
